import { ctaContainerStyles, linkButtonStyles } from 'auth/AuthStyles';

import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { REGISTER } from 'portal/constants/Routes';
import AuthLayout from 'auth/AuthLayout';
import LinkButton from '@opploans/link-button-component/LinkButton';
import PasswordResetEmailForm from 'auth/reset_password/PasswordResetEmailForm';
import React from 'react';
import reducer from 'reducers/reducer';

const store = configureStore({
  reducer,
  preloadedState: {
    errors: {},
    isDisabled: {},
    email: ''
  }
});

function AuthPasswordNew({ navigate }) {
  return (
    <AuthLayout
      title='Reset Your Password'
      subTitle='Enter the email associated with your account.'
      subHeaderStyles={{ textAlign: 'center' }}
    >
      <div>
        <Provider store={store}>
          <PasswordResetEmailForm navigate={navigate} />
        </Provider>
        <div css={ctaContainerStyles}>
          <LinkButton
            lightBackground
            additionalStyle={linkButtonStyles}
            onClick={() => navigate(REGISTER)}
          >
            Don’t have an account? Apply for a loan here
          </LinkButton>
        </div>
      </div>
    </AuthLayout>
  );
}

export default AuthPasswordNew;
